var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"competency-chart-card"},[(_vm.isLoading)?_c('b-spinner',{staticClass:"spinner",attrs:{"variant":"info","type":"grow"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }